{
  "tabs": {
    "chat": "ជជែក",
    "reminders": "ការរំលឹក",
    "calendar": "ប្រតិទិន",
    "settings": "ការកំណត់"
  },
  "common": {
    "cancel": "បោះបង់",
    "save": "រក្សាទុក",
    "confirm": "បញ្ជាក់",
    "delete": "លុប",
    "back": "ត្រឡប់ក្រោយ",
    "close": "បិទ",
    "edit": "កែប្រែ",
    "search": "ស្វែងរក",
    "all": "ទាំងអស់",
    "loading": "កំពុងផ្ទុក...",
    "error": "មានបញ្ហាអ្វីមួយ",
    "notFound": "រកមិនឃើញ",
    "tryAgain": "សូមព្យាយាមម្តងទៀត",
    "retry": "ព្យាយាមម្ដងទៀត",
    "undo": "បោះបង់",
    "pullToRefresh": "ទាញដើម្បីបន្ទាន់សម័យ",
    "justNow": "ទើបតែ"
  },
  "auth": {
    "welcome": "សូមស្វាគមន៍មកកាន់ FishMemory",
    "tagline": "ជំនួយការរំលឹក WhatsApp របស់អ្នក ឥឡូវនៅក្នុងកាបូបរបស់អ្នក។",
    "subtitle": "ជំនួយការរំលឹក WhatsApp របស់អ្នក ឥឡូវនៅក្នុងកាបូបរបស់អ្នក។",
    "phoneLabel": "លេខ WhatsApp របស់អ្នក",
    "phoneHint": "យើងនឹងផ្ញើកូដផ្ទៀងផ្ទាត់តាម WhatsApp",
    "invalidPhone": "សូមបញ្ចូលលេខទូរស័ព្ទត្រឹមត្រូវ",
    "continue": "បន្ត",
    "enterPhone": "បញ្ចូលលេខ WhatsApp របស់អ្នក",
    "phonePlaceholder": "លេខទូរស័ព្ទ",
    "sendCode": "ផ្ញើកូដ",
    "verifyTitle": "ផ្ទៀងផ្ទាត់លេខរបស់អ្នក",
    "otpSentTo": "កូដ 6 ខ្ទង់ត្រូវបានផ្ញើទៅ {{phone}} តាម WhatsApp",
    "enterFullCode": "សូមបញ្ចូលលេខទាំង 6 ខ្ទង់",
    "invalidOtp": "កូដមិនត្រឹមត្រូវ។ សូមព្យាយាមម្តងទៀត។",
    "otpFailed": "បរាជ័យក្នុងការផ្ញើកូដ។ សូមព្យាយាមម្តងទៀត។",
    "otpResent": "បានផ្ញើកូដម្តងទៀត",
    "resendIn": "ផ្ញើម្តងទៀតក្នុង {{seconds}} វិនាទី",
    "resendCode": "ផ្ញើកូដម្តងទៀត",
    "enterOtp": "បញ្ចូលកូដដែលបានផ្ញើទៅ WhatsApp របស់អ្នក",
    "verify": "ផ្ទៀងផ្ទាត់",
    "resend": "ផ្ញើកូដម្តងទៀត",
    "wrongNumber": "លេខខុស?",
    "backToPhone": "ត្រឡប់ទៅលេខទូរស័ព្ទ",
    "editPhone": "កែលេខទូរស័ព្ទ",
    "error": "កំហុស",
    "setupTitle": "ចាប់ផ្តើមកំណត់",
    "setupSubtitle": "អ្នកអាចផ្លាស់ប្តូរបាននៅពេលក្រោយក្នុងការកំណត់",
    "namePlaceholder": "ឈ្មោះរបស់អ្នក",
    "letsGo": "បញ្ចប់ការកំណត់",
    "skipForNow": "រំលងបច្ចុប្បន្ន"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "វាយសារ...",
    "inputPlaceholder": "វាយសារ...",
    "typing": "FishMemory កំពុងវាយ...",
    "online": "អនឡាញ",
    "connecting": "កំពុងភ្ជាប់...",
    "reconnecting": "កំពុងភ្ជាប់ឡើងវិញ...",
    "offline": "អอฟឡាញ",
    "empty": "ចាប់ផ្តើមជជែក",
    "emptyHint": "បង្កើតការរំលឹក ពិនិត្យកាលវិភាគ ឬសុំជំនួយ។",
    "emptyAction": "ផ្ញើការរំលឹកគំរូ",
    "actions": "សកម្មភាពជជែក",
    "keep": "រក្សាសារ",
    "clearTitle": "សម្អាតជជែក",
    "clearConfirm": "លុបសារទាំងអស់ពីឧបករណ៍នេះ? មិនអាចដកវិញបាន។",
    "clear": "សម្អាតជជែក",
    "optionSelected": "បានជ្រើស: {{label}}",
    "sendingSelection": "កំពុងផ្ញើ...",
    "connectionLost": "កំពុងភ្ជាប់ឡើងវិញ..."
  },
  "reminders": {
    "title": "ការរំលឹករបស់ខ្ញុំ",
    "active": "សកម្ម",
    "today": "ថ្ងៃនេះ",
    "thisWeek": "សប្តាហ៍នេះ",
    "history": "ប្រវត្តិ",
    "items": "ធាតុ",
    "emptyTitle": "មិនមានការរំលឹកទេ",
    "emptySubtitle": "បង្កើតពីជជែក ហើយវានឹងបង្ហាញនៅទីនេះ។",
    "emptyAction": "បើកជជែក",
    "filterActive": "សកម្ម",
    "filterToday": "ថ្ងៃនេះ",
    "filterWeek": "សប្តាហ៍នេះ",
    "filterHistory": "ប្រវត្តិ",
    "emptyState": "មិនមានការរំលឹកទេ។ ចាប់ផ្តើមជជែក!",
    "swipeDone": "បានធ្វើរួច",
    "swipeSnooze": "ពន្យាពេល",
    "swipeDelete": "លុប",
    "search": "ស្វែងរកការរំលឹក...",
    "upcoming": "ខាងមុខ",
    "completed": "បានបញ្ចប់",
    "overdue": "ហួសកំណត់",
    "tomorrow": "ស្អែក",
    "synced": "បានសមកាលកម្ម {{value}}",
    "swipeHint": "បញ្ច្រាស់ការរំលឹកសម្រាប់សកម្មភាពបន្ថែម",
    "noResults": "គ្មានការរំលឹកត្រូវនឹងការស្វែងរក",
    "noResultsHint": "សាកល្បងពាក្យផ្សេង ឬសម្អាតការស្វែងរក",
    "deleteAllFailed": "បរាជ័យក្នុងការលុបការរំលឹកទាំងអស់"
  },
  "calendar": {
    "title": "ប្រតិទិន",
    "today": "ថ្ងៃនេះ",
    "tomorrow": "ស្អែក",
    "completed": "បានធ្វើរួច",
    "noEvents": "គ្មានព្រឹត្តិការណ៍",
    "noEventsSubtitle": "ជ្រើសរើសថ្ងៃ ដើម្បីមើលការរំលឹក និងព្រឹត្តិការណ៍ប្រតិទិន។",
    "googleEvent": "ប្រតិទិន Google",
    "legendActive": "សកម្ម",
    "legendRecurring": "កើតឡើងម្តងម្ដង",
    "legendDone": "បានធ្វើរួច",
    "legendGoogle": "Google",
    "previousMonth": "ខែមុន",
    "nextMonth": "ខែក្រោយ",
    "previousYear": "ឆ្នាំមុន",
    "nextYear": "ឆ្នាំក្រោយ",
    "goToToday": "ទៅថ្ងៃនេះ",
    "all": "ទាំងអស់",
    "active": "សកម្ម",
    "done": "បានធ្វើរួច",
    "paused": "បានផ្អាក"
  },
  "settings": {
    "title": "ការកំណត់",
    "profile": "ប្រវត្តិរូប",
    "name": "ឈ្មោះបង្ហាញ",
    "enterName": "បញ្ចូលឈ្មោះរបស់អ្នក",
    "language": "ភាសា",
    "uiLanguage": "ភាសា UI",
    "uiLanguageHelp": "ផ្លាស់ប្តូរផ្ទៃ UI កម្មវិធី ស្លាកប្រតិទិន និងទិសដៅលំនាំនៅលើឧបករណ៍នេះតែប៉ុណ្ណោះ។",
    "serverLanguage": "ភាសាជជែក",
    "serverLanguageHelp": "ផ្លាស់ប្តូរភាសាដែលម៉ាស៊ីនមេប្រើសម្រាប់ការឆ្លើយតប និងសាររំលឹកសម្រាប់គណនីរបស់អ្នក។",
    "timezone": "តំបន់ម៉ោង",
    "currentTimezone": "តំបន់ម៉ោងបច្ចុប្បន្ន",
    "timezoneHelp": "ពេលវេលារបស់ការរំលឹកទាំងអស់បង្ហាញដោយប្រើតំបន់ម៉ោងនេះ។",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "រក្សាទុកតំបន់ម៉ោង",
    "timezoneSaved": "បានធ្វើបច្ចុប្បន្នភាពតំបន់ម៉ោង",
    "detect": "រកឃើញ",
    "detectFailed": "រកមិនឃើញតំបន់ម៉ោង",
    "autoDetect": "រកឃើញដោយស្វ័យប្រវត្តិពី GPS",
    "notifications": "ការជូនដំណឹង",
    "notificationsHelp": "ការរំលឹកបន្តគ្រប់គ្រងការជូនដំណឹងម្តងទៀតបន្ទាប់ពីការរំលឹកត្រូវបានផ្ញើ។ សិទ្ធិការជូនដំណឹងនៅលើឧបករណ៍ត្រូវគ្រប់គ្រងនៅក្នុងការកំណត់ទូរស័ព្ទរបស់អ្នក។",
    "pushEnabled": "ការជូនដំណឹង Push",
    "autoDoneOnFire": "សម្គាល់ដោយស្វ័យប្រវត្តិពេលរំលឹក",
    "autoDoneOnFireDesc": "បើបិទ ការរំលឹកនឹងនៅសកម្មរហូតដល់អ្នកសម្គាល់ថាបានបញ្ចប់។",
    "googleCalendar": "ប្រតិទិន Google",
    "google": "ប្រតិទិន Google",
    "googleConnected": "បានភ្ជាប់",
    "googleDisconnected": "មិនបានភ្ជាប់",
    "googleConnectedHelp": "ការរំលឹកថ្មីអាចសមកាលកម្មទៅប្រតិទិនរបស់អ្នកដោយស្វ័យប្រវត្តិ។",
    "googleDisconnectedHelp": "ភ្ជាប់ប្រតិទិន Google ដើម្បីរក្សាការរំលឹក និងព្រឹត្តិការណ៍ឲ្យសមស្រប។",
    "googleConnectFailed": "បរាជ័យក្នុងការភ្ជាប់ប្រតិទិន Google",
    "connected": "បានភ្ជាប់",
    "disconnected": "មិនបានភ្ជាប់",
    "connect": "ភ្ជាប់",
    "disconnect": "ផ្តាច់",
    "autoSync": "សមកាលកម្មការរំលឹកថ្មីដោយស្វ័យប្រវត្តិ",
    "autosync": "សមកាលកម្មការរំលឹកថ្មីដោយស្វ័យប្រវត្តិ",
    "subscription": "ការជាវ",
    "trialUsed": "សាកល្បង៖ {{used}}/{{total}} បានប្រើ",
    "trialStatus": "មានសាកល្បង",
    "activeStatus": "ជាវសកម្ម",
    "expiredStatus": "ការជាវផុតកំណត់",
    "unsubscribedStatus": "មិនបានជាវ",
    "about": "អំពី",
    "version": "កំណែ",
    "logout": "ចាកចេញ",
    "logoutTitle": "ចាកចេញ",
    "logoutConfirm": "តើអ្នកប្រាកដថាចង់ចាកចេញមែនទេ?",
    "noName": "មិនមានឈ្មោះកំណត់",
    "serverConnection": "ការភ្ជាប់ម៉ាស៊ីនមេ",
    "serverUrl": "URL ម៉ាស៊ីនមេ",
    "serverEdit": "កែប្រែ",
    "saveReconnect": "រក្សាទុក និងភ្ជាប់ឡើងវិញ",
    "resetDefault": "កំណត់ឡើងវិញ",
    "invalidServerUrlTitle": "URL ម៉ាស៊ីនមេមិនត្រឹមត្រូវ",
    "invalidServerUrlMessage": "សូមបញ្ចូល URL ម៉ាស៊ីនមេ http ឬ https ត្រឹមត្រូវ ឧទាហរណ៍ https://example.com",
    "uiLanguageChangeFailed": "បរាជ័យក្នុងការផ្លាស់ប្តូរភាសាកម្មវិធី។ សូមព្យាយាមម្តងទៀត។",
    "serverLanguageChangeFailed": "បរាជ័យក្នុងការផ្លាស់ប្តូរភាសាជជែក។ សូមព្យាយាមម្តងទៀត។",
    "timezoneChangeFailed": "បរាជ័យក្នុងការផ្លាស់ប្តូរតំបន់ម៉ោង។ សូមព្យាយាមម្តងទៀត។",
    "autoSyncChangeFailed": "បរាជ័យក្នុងការអាប់ដេតសមកាលកម្មដោយស្វ័យប្រវត្តិ។ សូមព្យាយាមម្តងទៀត។",
    "nameChangeFailed": "បរាជ័យក្នុងការអាប់ដេតឈ្មោះបង្ហាញ។ សូមព្យាយាមម្តងទៀត។",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "ព័ត៌មានលម្អិតការរំលឹក",
    "editTime": "កែពេលវេលា",
    "rename": "ប្ដូរឈ្មោះ",
    "snooze": "ពន្យាពេល",
    "snooze15": "ពន្យាពេល 15 នាទី",
    "pause": "ផ្អាក",
    "pauseReminder": "ផ្អាកការរំលឹក",
    "resume": "បន្ត",
    "resumeReminder": "បន្តការរំលឹក",
    "skip": "រំលងបន្ទាប់",
    "skipOccurrence": "រំលងករណីនេះ",
    "syncGoogle": "សមកាលកម្មទៅ Google",
    "delete": "លុប",
    "deleteTitle": "លុបការរំលឹក",
    "deleteConfirm": "ការរំលឹកនេះនឹងត្រូវបានលុបចោលជាអចិន្ត្រៃយ៍។",
    "deleteRecurringTitle": "លុបការរំលឹកកើតឡើងម្តងម្ដង",
    "deleteRecurringMessage": "តើអ្នកចង់រំលងករណីនេះ ឬលុបស៊េរីទាំងមូល?",
    "deleteThisOccurrence": "រំលងករណីនេះ",
    "deleteEntireSeries": "លុបស៊េរីទាំងមូល",
    "done": "បានធ្វើរួច",
    "markDone": "សម្គាល់ថាបានធ្វើរួច",
    "undo": "ស្ដារឡើងវិញ",
    "undoPrompt": "ត្រូវការឲ្យវាសកម្មម្តងទៀត? ស្ដារឡើងវិញឥឡូវនេះ។",
    "recurring": "កើតឡើងម្តងម្ដង",
    "nextRun": "រត់បន្ទាប់",
    "oneTime": "មួយដង",
    "pending": "កំពុងរង់ចាំ",
    "sent": "បានផ្ញើ",
    "paused": "បានផ្អាក",
    "active": "សកម្ម",
    "snoozed": "បានពន្យាពេល",
    "localTime": "បង្ហាញពេលវេលាតំបន់របស់អ្នក",
    "recurrence": "ការកើតឡើងម្តងម្ដង",
    "created": "បានបង្កើត",
    "tags": "ស្លាក",
    "fireCount": "ចំនួនដងបានរំលឹក",
    "actions": "សកម្មភាព",
    "none": "គ្មាន",
    "snoozeFailed": "បរាជ័យក្នុងការពន្យាពេលការរំលឹក",
    "pauseFailed": "បរាជ័យក្នុងការផ្អាកការរំលឹក",
    "resumeFailed": "បរាជ័យក្នុងការបន្តការរំលឹក",
    "skipFailed": "បរាជ័យក្នុងការរំលងការរំលឹក",
    "doneFailed": "បរាជ័យក្នុងការសម្គាល់ការរំលឹកថាបានធ្វើរួច",
    "undoFailed": "បរាជ័យក្នុងការស្ដារស្ថានភាពការរំលឹក",
    "deleteFailed": "បរាជ័យក្នុងការលុបការរំលឹក",
    "rescheduleTitle": "ប្តូរពេលវេលា?",
    "rescheduleMsg": "ការរំលឹកនេះហួសកំណត់។ តើអ្នកចង់ប្តូរពេលវេលាម្តងទៀតទេ?",
    "reschedule15": "ក្នុង 15 នាទី",
    "reschedule60": "ក្នុង 1 ម៉ោង",
    "keepOverdue": "រក្សាទុកដូចដែលមាន"
  },
  "onboarding": {
    "slide1Title": "សូមស្វាគមន៍មកកាន់ FishMemory",
    "slide1Sub": "ជំនួយការរំលឹកផ្ទាល់ខ្លួនរបស់អ្នក — ដំណើរការដោយ WhatsApp និងរចនាសម្រាប់កាបូបរបស់អ្នក។",
    "slide2Title": "គ្រាន់តែជជែកធម្មតា",
    "slide2Sub": "វាយការរំលឹកដូចដែលអ្នកគិត៖ «រំលឹកខ្ញុំទូរស័ព្ទទៅម៉ាក់ស្អែកម៉ោង 3 ល្ងាច» — យើងនឹងដោះស្រាយសម្រាប់អ្នក។",
    "slide3Title": "មិនភ្លេចអ្វីទេ",
    "slide3Sub": "ទទួលបានការជូនដំណឹងទាន់ពេលវេលា រៀបចំជាមួយស្លាក និងគ្រប់គ្រងអ្វីដែលសំខាន់។",
    "getStarted": "ចាប់ផ្តើម",
    "next": "បន្ទាប់",
    "firstReminderTitle": "បង្កើតការរំលឹកដំបូងរបស់អ្នក!",
    "firstReminderHint": "សាកវាយអ្វីមួយដូចជា៖",
    "firstReminderExample": "រំលឹកខ្ញុំផឹកទឹកស្អែកម៉ោង 9 ព្រឹក",
    "gotIt": "យល់ហើយ!",
    "notifRationaleTitle": "នៅលើពេលវេលា",
    "notifRationaleBody": "FishMemory ត្រូវការជូនដំណឹងដើម្បីរំលឹកអ្នកទាន់ពេល។ អ្នកនឹងទទួលបានការជូនដំណឹងសម្រាប់ការរំលឹកដែលអ្នកបង្កើតតែប៉ុណ្ណោះ។",
    "notifRationaleAllow": "បើកការជូនដំណឹង",
    "notifRationaleLater": "ប្រហែលជាពេលក្រោយ",
    "swipeHint": "បញ្ច្រាស់ទៅស្តាំសម្រាប់សកម្មភាពរហ័ស →",
    "calendarDragHint": "ទាញដើម្បីពង្រីក ↕"
  }
}
